<template lang="pug">
.customer-extended-stat.blue-gradient.px-3(v-if='data')
  .big-grade {{ grade.toUpperCase() }}
  .extended-stat-data.w-100.px-4.py-4

    .w-100.mb-2
      span.h6.font-weight-normal.text-secondary: small เงื่อนไขสำคัญ

    .item.w-25
      .key % วงเงินหลังจากออเดอร์นี้
      .value(:class="percentCreditAfterThisOrder.isGood ? 'green' : 'red'")
        | {{percentCreditAfterThisOrder.value | currency}}%

    .item.w-25
      .key บิลที่ค้างชำระเกิน 75 วัน
      .value(:class="outstanding75Days.isGood ? 'green' : 'red'")
        | {{outstanding75Days.value}} บิล

    .item.w-25
      .key เช็คเด้งในระบบ
      .value(:class="currentProblematicChecks.isGood ? 'green' : 'red'")
        | {{currentProblematicChecks.value}} ใบ

    .w-25

    hr.my-3.w-100
    .w-100.mb-2
      span.h6.font-weight-normal.text-secondary: small ข้อมูลอื่นๆ

    .item.w-25.pb-4
      .key วงเงินหลังจากออเดอร์นี้
      .value(:class="creditAfterThisOrder.isGood ? '' : ''")
        | {{creditAfterThisOrder.value | currency}}

    .item.w-25.pb-4
      .key ยอดเงินเช็คล่วงหน้า
      .value(:class="advanceCheckAmount.isGood ? '' : ''")
        | {{advanceCheckAmount.value}}

    .item.w-25.pb-4
      .key เช็คเด้งทั้งหมด
      .value(:class="returnedChecks.isGood ? '' : ''")
        | {{returnedChecks.value}} ใบ

    .item.w-25.pb-4
      .key เช็คเด้งในรอบ 12 เดือน
      .value(:class="returnedChecksRecents.isGood ? '' : ''")
        | {{returnedChecksRecents.value}} ใบ

    .item.w-25
      .key ปีที่เริ่มทำการค้าครั้งแรก
      .value(:class="firstOrderYear.isGood ? '' : ''")
        | {{firstOrderYear.value}}

    .item.w-25
      .key ยอดซื้อสะสม
      .value(:class="totalOrderSum.isGood ? '' : ''")
        | {{totalOrderSum.value | currency}}
</template>

<script>
export default {
  computed: {
    percentCreditAfterThisOrder() {
      const value = (
        parseFloat(this.creditAfterThisOrder.value)
        / parseFloat(this.data.account.credit)
      ) * 100;
      return { value, isGood: (value >= -20) };
    },
    creditAfterThisOrder() {
      const value = parseFloat(this.data.account.remaining_credit) - parseFloat(this.order.total);
      return { value, isGood: (value >= 0) };
    },
    outstanding75Days() {
      const value = parseInt(this.data.account.outstanding_bills_75days, 10);
      return { value, isGood: (value === 0) };
    },
    returnedChecks() {
      const value = parseInt(this.data.account.returned_checks, 10);
      return { value, isGood: (value === 0) };
    },
    firstOrderYear() {
      const value = this.data.account.first_order_year;
      return { value: value || '-', isGood: true };
    },
    advanceCheckAmount() {
      const value = this.data.account.advance_check_amount;
      return { value, isGood: (value === 0) };
    },
    currentProblematicChecks() {
      // const value = 0;
      const value = parseInt(this.data.account.problematic_checks, 10);
      return { value, isGood: (value === 0) };
    },
    returnedChecksRecents() {
      const value = 0; // TODO: Value is not yet provided
      // const value = parseInt(this.data.account.returned_checks_recent, 10);
      return { value, isGood: (value === 0) };
    },
    totalOrderSum() {
      const value = 0; // TODO: Value is not yet provided
      // const value = parseFloat(this.data.account.total_order_sum);
      return { value, isGood: (value > 0) };
    },
  },
  props: {
    order: {},
    grade: {
      default: '...',
    },
    data: {
      default: () => {},
      // default: () => ({
      //   extendedStat: {
      //     overLimitPercentage: 5,
      //     remainingQuota: -10000,

      //     outstandingBillCount: 1,
      //     chequeCount: {
      //       total: 5,
      //       thisYear: 4,
      //     },

      //     customerType: 2562,
      //     lifetimeSpends: 98000.56,

      //     advanceChequeAmount: 20000,
      //   },
      // }),
    },
  },
};
</script>

<style lang="scss">
.customer-extended-stat {
  .big-grade {
    position: absolute;
    right: 24px;
    top: -64px;
    font-size: 200px;
    font-weight: 500;
    color: var(--primary);
    opacity: 0.1;
  }
  .extended-stat-data {
    display: flex;
    flex-wrap: wrap;
    .item {
      .key {
        font-size: 15px;
        opacity: 0.5;
        letter-spacing: 1px;
      }
      .value {
        font-size: 17px;
        &.red {
          color: #E11A1A;
          font-weight: 500;
        }
        &.green {
          color: #0DA22E;
          font-weight: 500;
        }
      }
    }
  }
}

</style>
